import React, { Suspense } from "react";
import { useTheme } from "@mui/material";
import { ClickAwayListener, Popper, CircularProgress, Box } from "@mzc-pdc/ui";
import { styled } from "@mzc-pdc/ui";

// Lazy load EmojiPicker for better performance
const EmojiPicker = React.lazy(() => import("emoji-picker-react"));

const StyledPopper = styled(Popper)(({ theme }) => ({
    zIndex: "9999",
    borderRadius: "8px",
    border: `1px solid ${theme.palette.greySecondary[600]}`,
    boxShadow: "0px 3px 6px 0px rgba(0,0,0,0.32)",
}));
const EmojiPickerPopper = React.memo(({ placement, disablePortal, onClose, open, anchorEl, onEmojiClick }) => {
    const theme = useTheme();

    return (
        <ClickAwayListener onClickAway={onClose}>
            <StyledPopper open={open} anchorEl={anchorEl} placement={placement} disablePortal={disablePortal}>
                <Suspense
                    fallback={
                        <Box
                            sx={{
                                height: 450,
                                width: 350,
                                display: "flex",
                                justifyContent: "center",
                                alignItems: "center",
                                backgroundColor: "white",
                                borderRadius: "8px",
                            }}
                        >
                            <CircularProgress size={32} color="grey" />
                        </Box>
                    }
                >
                    <EmojiPicker
                        onEmojiClick={onEmojiClick}
                        height={450}
                        theme={theme.palette.mode}
                        previewConfig={{
                            showPreview: false,
                        }}
                        searchDisabled={false}
                        skinTonesDisabled={true}
                        lazyLoadEmojis={true}
                    />
                </Suspense>
            </StyledPopper>
        </ClickAwayListener>
    );
});

EmojiPickerPopper.displayName = "EmojiPickerPopper";

export default EmojiPickerPopper;
